import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import classes from './ImagesCarousel.module.css';
import { generateRandomString } from 'shared/utility';

// function imagesLoaded(parentNode) {
//   const imgElements = parentNode.querySelectorAll('img');
//   for (const img of imgElements) {
//     if (!img.complete) {
//       return false;
//     }
//   }
//   return true;
// }

class ImagesCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedImagePosition: 0,
      selectedImageIndex: 0,
      // loading: true,
    };
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedImageIndex !== prevProps.selectedImageIndex) {
      this.setState({ selectedImageIndex: this.props.selectedImageIndex });
      this.selectImage(this.props.selectedImageIndex);
    }
  }

  handleImageStateChange = () => {
    // this.setState({
    //   loading: !imagesLoaded(this.galleryElement),
    // });
  };

  handleKeyDown = (e) => {
    if (this.props.show) {
      // arrow left/right button selects next/previous image
      if (e.keyCode === 37 && this.state.selectedImageIndex > 0) {
        this.selectImage(this.state.selectedImageIndex - 1);
      } else if (e.keyCode === 39) {
        if (this.state.selectedImageIndex < this.props.images.length - 1) {
          this.selectImage(this.state.selectedImageIndex + 1);
        } else {
          this.selectImage(0);
        }
      }
    }
  };

  selectImage = (imageIndex) => {
    const containerWidth = document.getElementById('container') ? document.getElementById('container').clientWidth : window.innerWidth;
    const wrapperWidth = document.getElementById('card-slider-wrapper')
      ? document.getElementById('card-slider-wrapper').clientWidth
      : window.innerWidth;
    const bumperWidths = (containerWidth - document.getElementById(imageIndex.toString()).clientWidth) / 2;
    const startEndBufferWidths = containerWidth ? containerWidth - 100 : 500;
    let selectedImagePosition = startEndBufferWidths;
    for (let i = 0; i < imageIndex; i += 1) {
      const imageIWidth = document.getElementById(i.toString()).clientWidth;
      selectedImagePosition = selectedImagePosition + imageIWidth + 8;
    }
    const selectedImageXTranslate = ((selectedImagePosition - bumperWidths) / wrapperWidth) * 100;
    console.log(`selectImage - imageIndex: ${imageIndex} - selectedImageXTranslate: ${selectedImageXTranslate}`);
    this.setState({ selectedImagePosition: selectedImageXTranslate, selectedImageIndex: imageIndex });
  };

  render = () => {
    const containerClasses = [classes.ImagesCarouselContainer];
    let images = null;

    const spinner = null;
    // if(this.state.loading) spinner = <Spinner lightColor={true}/>;
    if (this.props.images) {
      const startEndBufferWidths = document.getElementById('container') ? document.getElementById('container').clientWidth - 100 : 500;
      const maxWidth = document.body.scrollWidth - 100;
      const maxVideoHeight = 0.5625 * maxWidth;
      // const browserHeight = window.innerHeight;
      images = (
        <div
          className={classes.CardSliderWrapper}
          style={{ transform: `translateX(-${this.state.selectedImagePosition}%)`, visibility: !this.props.show ? 'hidden' : 'visible' }}
          id="card-slider-wrapper"
        >
          <div className={classes.Buffer} id="first-image-buffer" style={{ width: `${startEndBufferWidths}px` }} />
          {this.props.images.map((image, i) => {
            // const videoJsOptions =
            //   image.MediaType === 'Video'
            //     ? {
            //         liveui: true,
            //         autoplay: false,
            //         controls: true,
            //         width: `${maxWidth}px`,
            //         sources: [
            //           {
            //             src: `${this.props.images[i].FileURL}?${generateRandomString(12)}`,
            //             type: 'application/x-mpegURL',
            //           },
            //         ],
            //       }
            //     : null;
            return (
              <div
                className={i === this.state.selectedImageIndex ? [classes.ImageContainer, classes.Selected].join(' ') : classes.ImageContainer}
                onClick={() => this.selectImage(i)}
                id={i.toString()}
                key={this.props.images[i].Id}
                style={{
                  maxWidth: `${maxWidth}px`,
                  backgroundImage: `url(${this.props.images[i].FileURL}`,
                  backgroundPosition: '0 50%',
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                }}
              >
                {image.MediaType === 'Video' ? (
                  <div className={classes.VideoContainer} style={{ margin: `calc(50vh - ${maxVideoHeight / 2}px) auto` }}>
                    <ReactPlayer
                      className="react-player"
                      url={`${this.props.images[i].FileURL}?${generateRandomString(12)}`}
                      height={`${maxVideoHeight}px`}
                      controls
                    />
                  </div>
                ) : (
                  <img
                    onLoad={this.handleImageStateChange}
                    onError={this.handleImageStateChange}
                    className={classes.Image}
                    src={this.props.images[i].FileURL}
                    alt={`post-image-${i}`}
                    style={{ opacity: '0' }}
                  />
                )}
              </div>
            );
          })}
          <div className={classes.Buffer} style={{ width: `${startEndBufferWidths}px` }} onClick={() => this.selectImage(0)} />
        </div>
      );
    }
    if (this.props.show) containerClasses.push(classes.Shown);
    return (
      <div
        ref={(element) => {
          this.galleryElement = element;
        }}
        className={containerClasses.join(' ')}
        id="container"
      >
        <FontAwesomeIcon icon="times" className={classes.CloseIcon} onClick={() => this.props.close(0)} />
        {spinner}
        <div onKeyDown={this.handleKeyDown} className={classes.CardSlider}>
          {images}
        </div>
      </div>
    );
  };
}

export default ImagesCarousel;
